import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import ErrorPage from './Error';
import { ChakraProvider, extendTheme, ThemeConfig } from '@chakra-ui/react';

const router = createBrowserRouter([
  {
    path: 'reminder/:reminderId',
    element: <App />,
    errorElement: <ErrorPage />,
  },
  {
    path: 'r/:reminderId',
    element: <App />,
    errorElement: <ErrorPage />,
  },
]);

const chakraConfig: ThemeConfig = {
  initialColorMode: 'light',
  useSystemColorMode: false,
};

const chakraTheme = extendTheme({ config: chakraConfig });

const root = ReactDOM.createRoot(
  // @ts-ignore
  document.getElementById('root') as HTMLElement,
);
root.render(
  <React.StrictMode>
    <ChakraProvider theme={chakraTheme}>
      <RouterProvider router={router} />
    </ChakraProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
